import react,{useRef,useEffect,useState} from 'react'
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
  actionComplete,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import "./import-excel.scss";

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import importExcelService from "./import-excel.service";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import loader from './spinner.gif';
import { Tooltip } from '@syncfusion/ej2-popups';
import saleInvoiceService from "../sale-invoice/sale-invoice.service";
import Loader from './loader';
import moment from 'moment';

let uploadeddataGrid =[]
let rowTooltips =[]
let focusRowIdRef = null
export default function ImportExcel(props) { 

  const gridRef = useRef(null);

  const fileInput = useRef(null);
  const [file, setFile] = useState(null);

  const [excelData, setExcelData] = useState([]);
  const [startFrom, setStartFrom] = useState(2); // default start
  const [endTo, setEndTo] = useState(2); // default start
  
  
  const [loadGrid, setLoadGrid] = useState('');
  
  
  const [gridData, setGridData] = useState([]);

  const [loaderText, setLoaderText] = useState('Calling API…');
  const [loader, setLoader] = useState(false);
  
  
  const fileInputChange = async (e) => {
    console.log(e.target.files)
          setFile(null);  
        let files = e.target.files;
        const allowedExtensions = /(\.(xlsx|xls))$/i; // Only allow Excel files
     if (files.length > 1) {
        toast.error(<span style={{color:"#333"}}>ONLY ONE FILE IS ALLOWED, TRY AGAIN.</span> , {
          delay: 3000
        })
        e.target.value = ""; // Clear the input
        return;
    }

    if (!allowedExtensions.exec(files[0].name)) {
        toast.error(<span style={{color:"#333"}}>ONLY EXCEL FILES (.xlsx, .xls) ARE ALLOWED, TRY AGAIN.</span> , {
          delay: 3000
        })
            e.target.value = ""; // Clear the input if invalid file is found
            return;
        }
        
        let processedData = await importExcelService.readXlsxFile(files[0],props.inputType);
        console.log(processedData);
        if(processedData?.error){ 
          toast.error(<span style={{color:"#333"}}>${processedData.error}, TRY AGAIN.</span> , {
            delay: 200
          })
          e.target.value = ""; // Clear the input if invalid file is found
            return;
        }else if (processedData?.data.length === 0 ) {
        toast.error(<span style={{color:"#333"}}>EMPTY EXCEL FILE, TRY AGAIN.</span> , {
          delay: 200
        })
            e.target.value = ""; // Clear the input if invalid file is found
            return;
        }else{
          toast.success(<span style={{color:"#333"}}>FILE UPLOADED SUCCESSFULLY.</span> , {
          delay: 200
        })
        setExcelData(processedData.data);
        setEndTo(processedData.data.length + 1);
        setFile(files[0]);
        }

  }

   const generateFileSize = (bytes)=> {
  if (!bytes) return "0 Bytes";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
}


const processFile = async ()=>{ 
  console.log(file)
  if(excelData.length === 0) return;
  // console.log(excelData)
  if(excelData.length > 1 && startFrom > excelData.length) return toast.error(
  <span style={{ color: '#333' }}>please select valid start from index.</span>,
  { delay: 200 }
);
;
  if(endTo  - 1 > excelData.length) return toast.error(<span style={{color:"#333"}}>please select valid end to index.</span> , { delay: 200 })   ;
  

  setLoadGrid('loading')
  let filterRowsByIndex = excelData.filter((row,index)=>{ 
    let startIndex =startFrom -1
    let toIndex =endTo -1
    return  index >= startIndex -1 && index <= toIndex -1
  })
  console.log(filterRowsByIndex)
  let validateData = await importExcelService.ValidateDataAccordingRules(
    filterRowsByIndex
    ,props.inputType
    ,props.dataList
    ,props.duplicateType,
    props.duplicateColumns
    );
    console.log(validateData.columns)
    
    setLoadGrid('loaded')
    setGridData(validateData.data || [])
    uploadeddataGrid = validateData.data

    gridRef.current.setProperties({ dataSource: validateData.data || []  },false);

  // importExcelService.(file,excelData,props.inputType,startFrom,endTo,props.onSuccess,props.onError);
}



// ===================================== Main Section ==============================================
// ===================================== Main Section ==============================================
// ===================================== Main Section ==============================================
// ===================================== Main Section ==============================================
// ===================================== Main Section ==============================================


// ===================================== Grid Section START ============================================== 
// ===================================== Grid Section START ============================================== 
// ===================================== Grid Section START ============================================== 
// ===================================== Grid Section START ============================================== 
// ===================================== Grid Section START ============================================== 

const hideAllRowTooltips = () => {
  rowTooltips.forEach(tp => {
    if (tp) {
      tp.close();
      tp.destroy();
    }
  });

  rowTooltips.length = 0; // reset array
};



function prepareInvoicePayload(storeGridData,jsonString) {

  if (!storeGridData) return null;

  const invoiceDetails = storeGridData;

  // ---- MAIN OBJECT ----
  const mainData = {
    docDescription: invoiceDetails[0].invoiceType,
    invoiceDate: invoiceDetails[0].invoiceDate,
    sellerNTNCNIC: invoiceDetails[0].sellerNTNCNIC,
    buyerNTNCNIC: invoiceDetails[0].buyerNTNCNIC,
    invoiceRefNo: invoiceDetails[0].invoiceRefNo || '',
     scenarioId: '',
     ChallanNo:invoiceDetails[0].ChallanNo || '',
    ...(props.isSendBox === true && {
      scenarioId: invoiceDetails[0].scenarioId || ''
    }),
    FBRSaleInvoiceNo:null,
    SaleInvoiceJSON: jsonString,

  };

  // ---- DETAIL OBJECT ARRAY ----
  const detailItems = (invoiceDetails || []).map(item => ({
    hS_CODE: item.HSCode,
    HSCodeDetail: item?.HSCodeDetail || '-',
    productDescription: item.productDescription,
    rate:`${item.rate}%`,
    uoM: item.UOM,
    quantity: item.quantity,
    totalValues: item.totalValues,
    valueSalesExcludingST: item.valueSalesExcludingST,
    fixedNotifiedValueOrRetailPrice: item.fixedNotifiedValueOrRetailPrice,
    salesTaxApplicable: item.salesTaxApplicable,
    salesTaxWithheldAtSource: item.salesTaxWithheldAtSource,
    extraTax: item.extraTax,
    furtherTax: item.furtherTax,
    sroScheduleNo: item.sroScheduleNo,
    fedPayable: item.fedPayable,
    discount: item.discount,
    transactioN_Desc: item.transactioN_Desc,
    sroItemSerialNo: item.sroItemSerialNo,
    FBRSaleInvoiceDetailNo:null
  }));

  // ---- FINAL OBJECT FOR INSERT ----
  const finalPayload = {
    ...mainData,
    details: detailItems
  };

  return finalPayload;
}



 //  ==== CAPILALIZE STRING VALUE FUNC ===== START
 function normalizeValue(v) {
  if (v == null) return "";

  // If number → convert to string
  if (typeof v === "number") return v.toString();

  // If string with extra quotes → clean safely
  if (typeof v === "string") {
    // Try to JSON.parse (handles "\"7233516\"")
    try {
      const parsed = JSON.parse(v);

      // parsed might be a number or string → convert to string
      return parsed.toString();
    } catch (e) {
      // If parsing fails, remove wrapping quotes like "7233516"
      return v.replace(/^"|"$/g, "");
    }
  }

  // Any other type → fallback
  return String(v);
}
 const capitalizeWord = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
//  ==== CAPILALIZE STRING VALUE FUNC ===== END
const getBuyerRegistrationType = async (BuyerNTNCNIC) => { 
const CompanyIDResponse = await saleInvoiceService.getCompanyView();

let data = {
  Registration_No: BuyerNTNCNIC,
  CompanyID:  CompanyIDResponse.data.recordset[0].CompanyID
}

let response = await saleInvoiceService.getBuyerRegistrationType(data);
if (response) {
  return capitalizeWord(response?.data?.REGISTRATION_TYPE || '');
}
}
let validateEntry = async (params ,args,index, entrynO) => {
  console.log(gridRef.current?.pageSettings?.currentPage)
  // let gridPageNumber =gridRef.current?.pageSettings?.currentPage
  setLoader(true)
  setLoaderText('Validate Row By FBR')
  const grid = gridRef.current;
   const gridDataSource = [...gridData] || []
  hideAllRowTooltips();
  const storeGridData = gridDataSource.filter(re => re.EntryNo == args.EntryNo);

// ---------------------------------------+-+-+-+-+-+--------
// NEW CHECK — VERIFY BUYER REGISTRATION TYPE
// ----------------------------------------------
try {
  setGridData([])
  var fetchedType = await getBuyerRegistrationType(storeGridData[0].buyerNTNCNIC);

  console.log("Fetched Buyer Registration Type:", fetchedType);
  console.log("User BuyerRegistrationType:", args.buyerRegistrationType);

  // If mismatch → update row and stop validation
  if (
    fetchedType &&
    fetchedType.toString().trim().toLowerCase() !==
      args.buyerRegistrationType?.toString().trim().toLowerCase()
  ) {
      const updatedGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? {
            ...rw,
            hasFbrError: true,
            FBRbuyerRegistrationType: fetchedType,   // ✅ SAVE TYPE
            FBRError: {
              mainError: `Buyer registration type mismatch! FBR says: ${fetchedType}`
            }
          }
        : rw
    );

   
      //  grid.setProperties({ dataSource: updatedGrid },false);
      setGridData(updatedGrid)
      uploadeddataGrid = updatedGrid
//       grid.dataSource = updatedGrid;
// grid.refresh();

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
  

    return; // ❌ STOP — do NOT call validate API
  }

  // Types match → still store fetchedType
  const updatedGridTypeMatch = gridDataSource.map(rw =>
    rw.EntryNo === args.EntryNo
      ? { ...rw, FBRbuyerRegistrationType: fetchedType } // ✅ SAVE TYPE
      : rw
  );
console.log(updatedGridTypeMatch)
  //  grid.setProperties({ dataSource: updatedGridTypeMatch });
  // setGridData(updatedGridTypeMatch)
  // grid.dataSource =updatedGridTypeMatch

  // grid.refresh();



} catch (err) {
  console.error("RegistrationType API Failed", err);

  const updatedGrid = gridDataSource.map(rw =>
    rw.EntryNo === args.EntryNo
      ? {
          ...rw,
          hasFbrError: true,
          FBRbuyerRegistrationType: "",               // ❌ UNKNOWN TYPE
          FBRError: { mainError: "Unable to verify buyer registration type" }
        }
      : rw
  );
  //  grid.setProperties({ dataSource: updatedGrid },false);
  setGridData(updatedGrid)
  uploadeddataGrid = updatedGrid
// //   grid.dataSource = updatedGrid;

// // grid.refresh();

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
  
  return;
}

  // const storeGridData = gridDataSource.filter(re => re.EntryNo == args.EntryNo);

  const validateObject = {
    invoiceType: storeGridData[0].invoiceType || 'Sale Invoice',
    invoiceDate: moment(storeGridData[0].invoiceDate).format('YYYY-MM-DD') || '2025-06-30',
    sellerNTNCNIC: normalizeValue(storeGridData[0].sellerNTNCNIC || ''),
    sellerBusinessName: storeGridData[0].sellerBusinessName,
    sellerProvince: storeGridData[0].sellerProvince,
    sellerAddress: storeGridData[0].sellerAddress,
    buyerNTNCNIC: storeGridData[0].buyerNTNCNIC,
    buyerBusinessName: storeGridData[0].buyerBusinessName,
    buyerProvince: storeGridData[0].buyerProvince,
    buyerAddress: storeGridData[0].buyerAddress,
    buyerRegistrationType: storeGridData[0].buyerRegistrationType,
    invoiceRefNo: storeGridData[0].invoiceRefNo,
    ChallanNo:storeGridData[0].ChallanNo || '',
    // scenarioId: (storeGridData[0].scenarioId || '').toUpperCase(),
    // scenarioId: '',
    ...(props.isSendBox === true && {
      scenarioId: (storeGridData[0].scenarioId || '').toUpperCase()
    }),
    items: storeGridData.map(res => ({
      hsCode: res.HSCode,
      productDescription: res.productDescription,
      rate: `${res.rate}%`,
      uoM: res.UOM,
      quantity: res.quantity,
      totalValues: res.totalValues,
      valueSalesExcludingST: res.valueSalesExcludingST,
      fixedNotifiedValueOrRetailPrice: res.fixedNotifiedValueOrRetailPrice,
      salesTaxApplicable: res.salesTaxApplicable,
      salesTaxWithheldAtSource: res.salesTaxWithheldAtSource,
      extraTax: res.extraTax,
      furtherTax: res.furtherTax,
      sroScheduleNo: res.sroScheduleNo,
      fedPayable: res.fedPayable,
      discount: res.discount,
      saleType: res.transactioN_Desc,
      sroItemSerialNo: res.sroItemSerialNo || ""
    }))
  };

  console.log("validateObject", validateObject);
 
  let validateResponse;

  // -----------------------------
  // Wrap API calls in try/catch
  // -----------------------------
  try {
    const CompanyIDResponse = await saleInvoiceService.getCompanyView();
    // validateResponse = await saleInvoiceService.validatePostDataTesting(
    //   CompanyIDResponse.data.recordset[0].CompanyID,
    //   validateObject
    // );
    if (props.isSendBox === true) {
      validateResponse = await saleInvoiceService.validatePostDataTesting(
        CompanyIDResponse.data.recordset[0].CompanyID,
        validateObject
      );
    } else {
      validateResponse = await saleInvoiceService.validatePostData(
        CompanyIDResponse.data.recordset[0].CompanyID,
        validateObject
      );
    }
  } catch (error) {
    console.error("API ERROR:", error);

    const updatedGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? { ...rw, hasFbrError: true, FBRError: { mainError:error.message || "FBR NOT RESPONDING, TRY AGAIN" },
        FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType

      }
        : rw
    );
    //  grid.setProperties({ dataSource: updatedGrid },false);
    console.log(updatedGrid)
    setGridData(updatedGrid)
    uploadeddataGrid = updatedGrid
//     grid.dataSource = updatedGrid;

// grid.refresh();

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
    return;
  }
  console.log(validateResponse)

  // -----------------------------
  // Handle validateResponse?.error
  // -----------------------------
  if (validateResponse?.error && validateResponse?.message) {
    const updatedGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? { ...rw, hasFbrError: true, FBRError: { mainError: validateResponse?.message} ,FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType}
        : rw
    );
    //  grid.setProperties({ dataSource: updatedGrid },false);
    setGridData(updatedGrid)
    uploadeddataGrid = updatedGrid
  //   grid.dataSource = updatedGrid;

  // setLoader(false)
  // setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);

    return;
  }
  if (validateResponse?.error) {
    const updatedGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? { ...rw, hasFbrError: true, FBRError: { mainError: "FBR NOT RESPONDING, TRY AGAIN" },FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType }
        : rw
    );
    //  grid.setProperties({ dataSource: updatedGrid },false);
    uploadeddataGrid = updatedGrid
    setGridData(updatedGrid)
//     grid.dataSource = updatedGrid;

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
    return;
  }

  const validationResponse = validateResponse?.data?.validationResponse;

  // -----------------------------
  // If no response from API
  // -----------------------------
  if (!validateResponse || !validationResponse) {
    const updatedGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? { ...rw, hasFbrError: true, FBRError: { mainError: "FBR NOT RESPONDING, TRY AGAIN" },FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType }
        : rw
    );

    //  grid.setProperties({ dataSource: updatedGrid },false);
    uploadeddataGrid = updatedGrid
    setGridData(updatedGrid)
//     grid.dataSource = updatedGrid;

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
    return;
  }

  // -----------------------------
  // VALID RESPONSE
  // -----------------------------
  if (validationResponse.status === "Valid") {
    const jsonString = JSON.stringify(validateObject);
    const payloadForTable = prepareInvoicePayload(storeGridData, jsonString);

    const newGrid = gridDataSource.map(rw =>
      rw.EntryNo === args.EntryNo
        ? {
            ...rw,
            validateRow: true,
            ValidateBtnDisable: true,
            FBRError: {},
            hasFbrError: false,
            FBRValidObject: validateObject,
            tableObject: payloadForTable,
            FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType
          }
        : rw
    );
    // grid.setProperties({ dataSource: newGrid },false);
    uploadeddataGrid = newGrid
    setGridData(newGrid)
//     grid.dataSource = newGrid;

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
    return;
  }

  // -----------------------------
  // INVALID RESPONSE
  // -----------------------------
  if (validationResponse.status === "Invalid") {
    const mainError = validationResponse.error?.trim() || null;
    const itemStatuses = Array.isArray(validationResponse.invoiceStatuses)
      ? validationResponse.invoiceStatuses
      : [];
// 1️⃣ Filter rows of current EntryNo (read only)


// 2️⃣ Create updated grid (full grid mapping)
let entryindex = 1;

const updatedGrid = gridDataSource.map((rw) => {

  // If row does NOT belong to this EntryNo → return unchanged
  if (rw.EntryNo !== args.EntryNo) return rw;

  let fbrErrorObj = {};

  // Add main error for all rows of this EntryNo
  if (mainError) {
    fbrErrorObj.mainError = mainError;
  }

  // Determine item number inside this EntryNo
  const currentItemNo = entryindex;

  // Find item-status entry
  const match = itemStatuses.find(
    st => Number(st.itemSNo) === Number(currentItemNo)
  );

  // If item is invalid, attach itemError
  if (match?.status === "Invalid" && match.error) {
    fbrErrorObj.itemError = match.error;
  }

  // IMPORTANT: increment only for rows of this EntryNo
  entryindex++;

  return {
    ...rw,
    hasFbrError: Object.keys(fbrErrorObj).length > 0,
    FBRError: fbrErrorObj,
    FBRbuyerRegistrationType: rw.buyerRegistrationType || fetchedType
  };
});


    //  grid.setProperties({ dataSource: updatedGrid },false);
    uploadeddataGrid = updatedGrid
    setGridData(updatedGrid)
//     grid.dataSource = updatedGrid;

// setLoader(false)
//   setLoaderText('Calling API…')
      
//       setTimeout(() => {
           
//        // after you call setGridData(updatedGrid) …

// // get row info from the clicked button
// const info = gridRef.current.getRowInfo(params.target);
// const rowIndex = info.rowIndex;

// // clear any previous selection
// gridRef.current.clearSelection();

// // select the row by index → highlights and focuses it
// gridRef.current.selectRow(rowIndex);

// // optional: scroll into view and add a custom class
// const rowEl = gridRef.current.getRowByIndex(rowIndex);
// if (rowEl) {
//   rowEl.scrollIntoView({ behavior: "smooth", block: "center" });
//   rowEl.classList.add("e-hover"); // your custom focus style
// }
// ;
//       }, 200);
  }
};

let validateClicked = async (params)=>{
  console.log('validate clicked',params)
  
    const grid = gridRef.current;
  
    // 1️⃣ Find clicked row
    const row = params.target.closest('.e-row .e-primary');
  if (!row) return;
  row.disabled = true
  // Add highlight to clicked row
  
  
  const rowElement = params.target.closest('.e-row');
  if (!rowElement) return;
  // rowElement.classList.add("row-loading");
  
  
    const uid = rowElement.getAttribute("data-uid");
    const rowObj = grid.getRowObjectFromUID(uid);
    if (!rowObj) return;
    console.log(rowObj)
  
    // const rowIndex = rowObj.index;
    const rowData = rowObj.data;
  
    try {
      const info = grid.getRowInfo(params.target);
      const props = info.rowData;
      // focusRowIdRef.current = props.ExcelRowID;  // or props.EntryNo

      const rowIndex = info.rowIndex; 
      const rowEl = gridRef.current.getRowByIndex(rowIndex);
      rowEl.classList.add('has-not-validD'); // red row


      // 4️⃣ RUN your big function
     await  validateEntry(params,rowData, rowIndex, rowData.EntryNo);
 
    } finally {
      // 6️⃣ Remove loading class + enable button after API
      // row.classList.remove("row-loading");
    }
  
  
}


// POST CODE START






function showAlert({ heading, message, type = 'info', autoClose = 3000, position = 'top-right' }) {
  if (!heading || !message) {
    console.error('❌ showAlert requires both heading and message.');
    return;
  }

  toast[type](
    <div>
      <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px', color: '#000' }}>
        {heading}
      </div>
      <div style={{ fontSize: '14px', color: '#000' }}>
        {message}
      </div>
    </div>,
    {
      position,
      autoClose,
      style: {
        // backgroundColor: '#eee',
        // border: '1px solid #ccc',
        borderRadius: '6px',
        padding: '12px',
      },
    }
  );
}
const validateAndInsert = async (args, validateObject) => {
  console.log("validateObject", validateObject);
  

  let validateResponse;

  try {
    const CompanyIDResponse = await saleInvoiceService.getCompanyView();
    // validateResponse = await saleInvoiceService.PostDataTesting(
    //   CompanyIDResponse.data.recordset[0].CompanyID,
    //   validateObject
    // );
    
if (props.isSendBox === true) {
  validateResponse = await saleInvoiceService.PostDataTesting(
    CompanyIDResponse.data.recordset[0].CompanyID,
    validateObject
  );
} else {
  validateResponse = await saleInvoiceService.PostData(
    CompanyIDResponse.data.recordset[0].CompanyID,
    validateObject
  );
}
  } catch (error) {
    ;

    showAlert({
      heading: 'FBR Error',
      message: 'FBR server not responding.',
      type: 'error',
      autoClose: 5000,
      position: 'bottom-right'
    });

    return updateRowWithError(args,"FBR NOT RESPONDING, TRY AGAIN");
  }
  
  const validationResponse = validateResponse?.data;

  if (!validationResponse.validationResponse) {
    showAlert({
      heading: 'FBR Error',
      message: 'Invalid response received from FBR.',
      type: 'error',
      autoClose: 5000,
      position: 'bottom-right'
    });

    return updateRowWithError(args,"FBR NOT RESPONDING, TRY AGAIN");
  }

  // ============================================
  // 3️⃣ VALID RESPONSE
  // ============================================
  if (validationResponse.validationResponse.status === "Valid") {

    // -----------------------------
    // 🟦 Toast A — FBR Validation Success
    // -----------------------------
    showAlert({
      heading: 'Success',
      message: `Invoice ${validationResponse.invoiceNumber} posted successfully to FBR.`,
      type: 'info',
      autoClose: 5000,
      position: 'bottom-right',
    });

    // -----------------------------
    // Remove validated row from UI
    // -----------------------------
    const removedGrid = gridRef.current.dataSource.filter(
      row => row.EntryNo !== args.EntryNo
    );

    uploadeddataGrid = removedGrid
    setGridData(removedGrid)
     gridRef.current.setProperties({ dataSource: removedGrid },false);

    // -----------------------------
    // Build insert table payload
    // -----------------------------
    const mainData = args.tableObject;
    const detailList = args.tableObject.details;

    // Set FBR invoice number
    const validInvoiceNumber = validationResponse.invoiceNumber;
    mainData.FBRSaleInvoiceNo = validInvoiceNumber;

    const invoiceStatuses = validationResponse?.validationResponse?.invoiceStatuses;

    // Details only contain FBRSaleInvoiceDetailNo (your requirement)
    const updatedDetails = detailList.map((row, index) => {
      const status = invoiceStatuses.find(
        st => Number(st.itemSNo) === index + 1
      );
    
      return {
        ...row,
        FBRSaleInvoiceDetailNo: status?.invoiceNo || null
      };
    });
    

    const finalPayload = {
      ...mainData,
      details: updatedDetails
    };

    // ---------------------------------
    // CALL INSERT API
    // ---------------------------------
    try {
      console.log('finalPayload',finalPayload)
      const insertResponse = await saleInvoiceService.insert(finalPayload);

      console.log("Insert Success:", insertResponse);

      // 🟩 Toast B — Table insert successful
      showAlert({
        heading: 'Success',
        message: `Invoice inserted successfully in table.`,
        type: 'success',
        autoClose: 5000,
        position: 'bottom-right',
      });

    } catch (error) {
      console.error("Insert API FAILED:", error);

      // 🟥 Toast B — Insert failed
      showAlert({
        heading: 'Insert Failed',
        message: 'Invoice validated but table insert failed. Try again.',
        type: 'error',
        autoClose: 5000,
        position: 'bottom-right',
      });

      return updateRowWithError(args,"INSERT API FAILED");
    }

    
    return;
  }

  // ============================================
  // 4️⃣ INVALID RESPONSE
  // ============================================
  if (validationResponse.validationResponse.status === "Invalid") {

    // 🟥 Toast A — FBR Validation Failed
    showAlert({
      heading: 'Invalid',
      message: `FBR Validation Failed.`,
      type: 'error',
      autoClose: 5000,
      position: 'bottom-right'
    });

    const mainError = validationResponse.error?.trim() || null;
    const itemStatuses = validationResponse.invoiceStatuses || [];

    const updatedGrid = gridRef.current.dataSource.map(rw => {
      if (rw.EntryNo !== args.EntryNo) return rw;

      let fbrErrorObj = {};

      if (mainError) fbrErrorObj.mainError = mainError;

      const match = itemStatuses.find(
        st => Number(st.itemSNo) === Number(rw.itemSNo || rw.SNo)
      );

      if (match?.status === "Invalid" && match.error) {
        fbrErrorObj.itemError = match.error;
      }

      return {
        ...rw,
        hasFbrError: Object.keys(fbrErrorObj).length > 0,
        FBRError: fbrErrorObj
      };
    });
   uploadeddataGrid = updatedGrid
    setGridData(updatedGrid)
    gridRef.current.setProperties({ dataSource: updatedGrid },false);

  }
};


const updateRowWithError = (args ,message) => {
  const updatedGrid = gridRef.current.dataSource.map(rw =>
    rw.EntryNo === args.EntryNo
      ? { ...rw, hasFbrError: true, FBRError: { mainError: message } }
      : rw
  );
 uploadeddataGrid = updatedGrid
    setGridData(updatedGrid)
  gridRef.current.setProperties({ dataSource: updatedGrid },true);
  // setTimeout(() => {
  //   console.log(currentPage)
  //   const gridWrapper = grids.current["InvoiceDetail"];
  //   if (!gridWrapper) return;
  //   const grid = gridWrapper.ej2Instances || gridWrapper;
  //   grid.goToPage(gridPageNumber);
    
  // }, 1200);
};

let postClicked = (params)=>{
  console.log('post clicked',params)
  console.log('validate clicked',params)
  
    const grid = gridRef.current;
  
    // 1️⃣ Find clicked row
    const row = params.target.closest('.e-row .e-danger');
  if (!row) return;
  row.disabled = true
  // Add highlight to clicked row
  
  
  const rowElement = params.target.closest('.e-row');
  if (!rowElement) return;
  // rowElement.classList.add("row-loading");
  
  
    const uid = rowElement.getAttribute("data-uid");
    const rowObj = grid.getRowObjectFromUID(uid);
    if (!rowObj) return;
    console.log(rowObj)
  
    const rowIndex = rowObj.index;
    const args = rowObj.data;
  
    try {
      const rowEl = gridRef.current.getRowByIndex(rowIndex);
      rowEl.classList.add('has-fbr-errorD'); // red row
      // 4️⃣ RUN your big function
      //  validateEntry(rowData, rowIndex, rowData.EntryNo);
      
  // --------------------------
  // 1️⃣ Check FBR Error flag
  // --------------------------
  if (args.hasFbrError === true) {
    showAlert({
      heading: 'FBR Error',
      message: 'Correct the FBR errors before posting.',
      type: 'error',
      autoClose: 5000,
      position: 'bottom-right'
    });
    return;
  }

  // --------------------------
  // 2️⃣ Check FBRValidObject exists
  // --------------------------
  const validateObj = args.FBRValidObject;

  const isValidObject =
    validateObj &&
    typeof validateObj === "object" &&
    Object.keys(validateObj).length > 0;

  if (!isValidObject) {
    showAlert({
      heading: 'FBR Error',
      message: 'FBR server not responding.',
      type: 'error',
      autoClose: 5000,
      position: 'bottom-right'
    });
    return;
  }

  // --------------------------
  // 3️⃣ All good → call validateAndInsert
  // --------------------------
  validateAndInsert(args,validateObj);
 
    } finally {
      // 6️⃣ Remove loading class + enable button after API
      // row.classList.remove("row-loading");
    }
  
}




  // Command definitions
  const validateButton = [
    {
      buttonOption: {
        content: "Validate",
        cssClass: "e-primary validateBtn",
        click: validateClicked
      }
    }
  ];
  const postButton = [
    {
      buttonOption: {
        content: "Post",
        cssClass: "e-danger postBtn",
        click: postClicked
      }
    }
  ];
  let currentPage = 1

  const  actionComplete = async (args)=>{
      if(args.requestType == 'add' || args.requestType == 'beginEdit'){
      // currentPage = gridRef.current?.pageSettings?.currentPage
      focusRowIdRef= null
      document.getElementById('InvoiceDetailGridinvoiceDate').focus()
      document.getElementById('InvoiceDetailGridinvoiceDate').select()
      document.querySelector(`#ImportExcel > #btnSave`).style.visibility='visible';

      document.getElementById('InvoiceDetailGridsroItemSerialNo').addEventListener('keydown',(tab)=>{
        if(tab?.code == 'Tab'){
          tab.preventDefault();
          setTimeout(() => {
            gridRef.current.endEdit()
          }, 400);
        }
        
      })
    }
    if (args.requestType === "beginEdit") {
      // disable only the command buttons in the current editing row
      const rowIndex = args.rowIndex;
      const row = gridRef.current.getRowByIndex(rowIndex);
      if (row) {
        const updateBtn = row.querySelector(".validateBtn");
        const deleteBtn = row.querySelector(".postBtn");
        if (updateBtn) updateBtn.disabled = true;
        if (deleteBtn) deleteBtn.disabled = true;
      }
    }
 
      if(args.requestType == 'save' || args.requestType == 'cancel'){
      document.querySelector(`#ImportExcel > #btnSave`).style.visibility='visible';
    }

    if (args.requestType === "save" || args.requestType === "cancel") {
      // reapply conditional logic after editing ends
      const rows = gridRef.current.getRows();
      rows.forEach((row) => {
        const uid = row.getAttribute("data-uid");
        const rowObj = gridRef.current.getRowObjectFromUID(uid);
        const rowData = rowObj.data;
    
        const validateBtn = row.querySelector(".validateBtn");
        const postBtn = row.querySelector(".postBtn");
    
        // ---- BUTTON DISABLE RULES ----
        const isError = rowData.hasBasicError === true;
        const disableValidate = isError || rowData?.ValidateBtnDisable; 
        const disablePost = isError || rowData.validateRow !== true;
    
        if (validateBtn) validateBtn.disabled = disableValidate;
        if (postBtn) postBtn.disabled = disablePost;
      });
    }
    
      if(args.requestType == 'save'){
        const ds = [...gridRef.current.dataSource];
          const updatedRow = args.data;
        
          // Step 1: Update storeData with both main + detail section logic
          let updateData1 = ds.map((res) => {
            return res.ExcelRowID === updatedRow.ExcelRowID
              ? {
                  ...res,
                  ...updatedRow,
                  EntryNo: updatedRow.EntryNo,
                  invoiceDate: moment(updatedRow.invoiceDate).format('YYYY-MM-DD') ,
                  invoiceRefNo: updatedRow.invoiceRefNo,
                  sellerNTNCNIC: updatedRow.sellerNTNCNIC,
                  sellerBusinessName: updatedRow.sellerBusinessName,
                  sellerProvince: updatedRow.sellerProvince,
                  buyerProvince: updatedRow.buyerProvince,
                  invoiceType: updatedRow.invoiceType,
                  buyerNTNCNIC: updatedRow.buyerNTNCNIC,
                  buyerBusinessName: updatedRow.buyerBusinessName,
                  sellerAddress: updatedRow.sellerAddress,
                  buyerAddress: updatedRow.buyerAddress,
                  buyerRegistrationType: updatedRow.buyerRegistrationType,
                  scenarioId: updatedRow.scenarioId ?? '',
                  ChallanNo: updatedRow.ChallanNo ?? '',
                  HSCode: updatedRow.HSCode,
                  productDescription: updatedRow.productDescription,
                  rate: updatedRow.rate,
                  UOM: updatedRow.UOM,
                  quantity: updatedRow.quantity,
                  totalValues: updatedRow.totalValues,
                  valueSalesExcludingST: updatedRow.valueSalesExcludingST,
                  fixedNotifiedValueOrRetailPrice:
                    updatedRow.fixedNotifiedValueOrRetailPrice,
                  salesTaxApplicable: updatedRow.salesTaxApplicable,
                  salesTaxWithheldAtSource: updatedRow.salesTaxWithheldAtSource,
                  extraTax: updatedRow.extraTax,
                  furtherTax: updatedRow.furtherTax,
                  sroScheduleNo: updatedRow.sroScheduleNo,
                  fedPayable: updatedRow.fedPayable,
                  discount: updatedRow.discount,
                  transactioN_Desc: updatedRow.transactioN_Desc,
                  sroItemSerialNo: updatedRow.sroItemSerialNo,
                }
              : { ...res};
          });
        
          // Step 2: Update only main section fields
          let updateData = updateData1.map((res) => {
            return res.EntryNo === updatedRow.EntryNo
              ? {
                  ...res,
                  invoiceDate: moment(updatedRow.invoiceDate).format('YYYY-MM-DD') ,
                  invoiceRefNo: updatedRow.invoiceRefNo,
                  sellerNTNCNIC: updatedRow.sellerNTNCNIC,
                  sellerBusinessName: updatedRow.sellerBusinessName,
                  sellerProvince: updatedRow.sellerProvince,
                  buyerProvince: updatedRow.buyerProvince,
                  invoiceType: updatedRow.invoiceType,
                  buyerNTNCNIC: updatedRow.buyerNTNCNIC,
                  buyerBusinessName: updatedRow.buyerBusinessName,
                  sellerAddress: updatedRow.sellerAddress,
                  buyerAddress: updatedRow.buyerAddress,
                  buyerRegistrationType: updatedRow.buyerRegistrationType,
                  scenarioId: updatedRow?.scenarioId ?? '',
                  ChallanNo: updatedRow?.ChallanNo ?? '',
                }
                : { ...res };
          });
        
          // Step 3: Validate updated data
          setGridData([]);
          let validateData = await importExcelService.ValidateDataAccordingRules(
            updateData,
            props.inputType,
            props.dataList,
            props.duplicateType,
            props.duplicateColumns
          );
        
          console.log("Validated Data:", validateData.data);
        
          // Step 4: Push validated data back into grid runtime
          // gridRef.current.setProperties({ dataSource: validateData.data },false);
          
          setGridData(validateData.data);
          uploadeddataGrid = validateData.data
          setTimeout(() => {
            console.log(currentPage)
            
            // gridRef.current.goToPage(currentPage);
            setTimeout(() => {
           
              const rowEl = gridRef.current.getRowByIndex(args.rowIndex);
              gridRef.current.getRows().forEach(r => r.classList.remove('e-hover'));
          
              if (rowEl) rowEl.scrollIntoView({ behavior: "smooth", block: "center" })
              gridRef.current.selectRow(args.rowIndex); // highlights the row
              // optional: scroll into view
              rowEl.classList.add('e-hover');
            }, 200);
          }, 2000);
        
        
      }
  }
  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };

  return (
    <>
    <div className="ImportExcel-Wrapper">
  <div className=" row">
  <ToastContainer 
             
              theme="light"
  toastStyle={{
    backgroundColor: '#ffffff',
    color: '#000000',
    border: '1px solid #ccc',
    borderRadius: '6px',
    padding: '12px',
  }}
  />    {/* ===============   file uploader Box Start   =============== */}
    <div id="upload-file-container" className="col-sm-4"
    onDrag={(e) => {e.preventDefault()}}
    onDragOver={(e) => {e.preventDefault()
      document.getElementById("upload-file-container").style.backgroundColor = "rgb(213, 229, 230)"
    }}
    onDrop={(e) => { 
      e.preventDefault()
      document.getElementById("upload-file-container").style.backgroundColor = "#e6e6e6"
      console.log(e)
      console.log(e.dataTransfer.files)
      const dt = new DataTransfer()
      for(let ffile of e?.dataTransfer?.files){
          console.log(ffile)
        dt.items.add(ffile)   // only first file
        // dt.items.add(e.dataTransfer.files[ffile])   // only first file
      }
        fileInput.current.files = dt.files      // set input value
        fileInput.current.dispatchEvent(new Event("change", { bubbles: true }))
    }}
    >
      <label id="fileSelect" htmlFor="file" >BROWSER...</label>
      <span className="drop-file-text">DROP FILE HERE</span>
      <input  
      id="file" 
      ref={fileInput}
      onChange={fileInputChange}
      type="file" 
      hidden 
      accept=".xlsx,.xls" />
    </div>
    {/* ===============   file uploader Box End   =============== */}
    
    {/* ===============   uploaded File Info Box Start   =============== */}
  {file ? (
    <div className="file-info-box col-sm-4">
    <div className="file-preview-box">
      <button className="clear-btn" onClick={() =>{
             document.getElementById("upload-file-container").style.backgroundColor = "#e6e6e6"
       setFile(null)
      }}>
        <span className='e-btn-icon e-icon-dlg-close e-icons'></span>
      </button>
      <p className="file-name">
        📄 {file.name} 
        </p>
      <p className="file-name">
         ({generateFileSize(file.size)})
        </p>
    </div>
  </div>
  ) : (
    <div className="no-file-info-box col-sm-4">
    <div className="file-preview">
      <span className="no-file-name">No file selected</span>
    </div>
    </div>
  )}

      </div>
    {/* ===============   uploaded File Info Box End   =============== */}

    {/* ===============   Processing File Button End   =============== */}
    <div className="row">
    <div className="col-sm-2">
      
        <TextBoxComponent
          id="rowStart"
          type="number"
          placeholder="Start from Row"
          floatLabelType="Auto"
          // onChange={(e) => setStartFrom(e.target.value)}
          // onKeyDown={(e) => {
          //   if (e.keyCode === 13) {
          //     setStartFrom(e.target.value);
          //   }
          // }}
          onChange={(e) => {
            const val = Math.max(2, Number(e.target.value));
            setStartFrom(val);
          }}
          // onKeyDown={(e) => {
          //   if (e.keyCode === 13) {
          //     setStartFrom(e.target.value);
          //   }
          // }} 
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              const val = Math.max(2, Number(e.target.value));
              setStartFrom(val);
            }
          }}
          value={startFrom}
          step="1"
          min="2"
          format='n0'
          max={excelData.length - 1}
          // maxlength={excelData.length - 1}
        />
          
      </div>
    <div className="col-sm-2">
      
        <TextBoxComponent
          id="rowEndTo"
          type="number"
          placeholder="to till row "
          floatLabelType="Auto"
          onChange={(e) => setEndTo(e.target.value)}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              setEndTo(e.target.value);
            }
          }}
          value={endTo}
          step="1"
          min="1"
          max={excelData.length}
          format='n0'
        />
          
      </div>
    <div className="col-sm-4 process-button">
      
      <button
        className="btn btn-primary btn-block"
        onClick={processFile}
        disabled={!file}
      >
        GET DATA
      </button>
    </div>
    </div>
    {/* ===============   Processing File Button End   =============== */}



<br />
<br />

<div className="row"> 
  {loadGrid  == 'loading' &&(

<div className="col-sm-12 loader-div-import-excel" >
  <img src={loader} alt="loader" className="loader-img-import-excel" />
  </div> 
  )

  }
<Loader visible={loader} text={loaderText} onClose={() =>{
  console.log(gridData)
  console.log(gridRef.current.dataSource)
  setGridData(uploadeddataGrid)
   setLoader(false)}} />
<div className="col-sm-12"> 
  {loadGrid  == 'loaded' && (

<GridComponent
  id='InvoiceDetailGrid'
  ref={gridRef}
  dataSource={gridData}
  actionComplete={actionComplete}
  actionBegin={(args) => {
    // disable all command buttons while editing
   
  if (args.requestType === "beginEdit") {
    const rows = gridRef.current.getRows();
    rows.forEach((row) => {
      const updateBtn = row.querySelector(".validateBtn");
      const deleteBtn = row.querySelector(".postBtn");
      if (updateBtn) updateBtn.disabled = true;
      if (deleteBtn) deleteBtn.disabled = true;
    });
  }
}}
  allowPaging={false}
  allowTextWrap={true}
  // pageSettings={{
  //   pageCount:4 ,
  //   pageSize: 50,                          // ✅ default page size
  //   pageSizes: [50, 75, 100, 150, 200, 'All'] // ✅ custom dropdown with "All"
  // }}
  editSettings={{ allowEditing: true, mode: "Normal" }}
  toolbar={["Edit", "Update", "Cancel"]}
  allowSorting={true}
  sortSettings={{ columns: [{ field: "ExcelRowID", direction: "Ascending" }] }}
  allowFiltering={false}
  allowGrouping={true}
  groupSettings={{ columns: ["EntryNo"] }}   // 👈 auto-group by EntryNo
  commandClick={
      (args, newData) => {
        console.log(args.rowData.ExcelRowID)
      focusRowIdRef = args.rowData.ExcelRowID;        // mark which row to focus
      
    }
  }
  rowDataBound={(args) => {
    console.log(args)
      const row = args.row;
      const data = args.data;
       // compare row identity
       console.log(focusRowIdRef)
       console.log('1529',data.ExcelRowID)
  if ( data.ExcelRowID === focusRowIdRef) {
    setTimeout(()=>{
    // ⭐ Add highlight class
    row.classList.add("e-hover");

    // ⭐ Scroll this row into view
    row.scrollIntoView({ behavior: "smooth", block: "center" });

    // ⭐ Also set grid selection
    gridRef.current.selectRow(args.rowIndex);
   

    if(gridRef.current.dataSource.length > 0){
      setTimeout(()=>{

        setLoader(false)
      },250)
      setLoaderText('Calling API…')
    }
    // clear so it doesn't repeat
    // focusRowIdRef = null;
  },1500)
  }
        // Buttons
        const validateBtn = args.row.querySelector(".validateBtn");
        const postBtn = args.row.querySelector(".postBtn");
      
        // ---- BUTTON DISABLE RULES ----
        const isError = data?.hasBasicError === true;
        const disableValidate = isError || data?.ValidateBtnDisable; // disable all if basic error
        const disablePost = isError || data?.validateRow !== true;
        // ---- Validate/Post logic ----
        if (validateBtn) validateBtn.disabled = disableValidate;
        if (postBtn) postBtn.disabled = disablePost;
      
      // RESET classes every time
      row.classList.remove("has-fbr-error", "has-valid-row", "has-not-valid",'has-fbr-errorD','has-not-validD');

   
      // ------------------------------
      // ❌ CASE 1 — ROW HAS BASIC ERRORS
      // ------------------------------
      if (data?.hasBasicError) {
        row.classList.add('has-not-valid'); // red row
    
        if (data.errors && typeof data.errors === 'object') {
          let errorMessages = Object.entries(data.errors)
            .map(([key, value]) =>
              `<span style="font-weight:bold;color:#d32f2f">${key.replace(/([a-z])([A-Z])/g, '$1 $2')}</span>: 
               <span style="color:#333">${value}</span>`
            )
            .join('<br/>');
    
          const tooltip = new Tooltip({
            content: errorMessages,
            position: 'TopLeft',
            opensOn: 'Hover',
            mouseTrail: true,
            offsetX: 20,
          });
    
    
          tooltip.appendTo(row); // show tooltip for errors
          rowTooltips.push(tooltip); // ⭐ STORE INSTANCE



        }
    
        return; // stop here
      }
    
      // ------------------------------
      // ✅ CASE 2 — ROW IS VALID
      // ------------------------------
      if (data?.validateRow === true && data?.FBRValidObject) {
        row.classList.add('has-valid-row'); // green row
        return; // no tooltip on valid rows
      }





      
// ------------------------------
// FBR ERROR ROW → DARK RED + TOOLTIP
// ------------------------------
if (data?.hasFbrError) {
row.classList.add("has-fbr-error");

let html = "";

if (data.FBRError.mainError) {
html += `<div><b style="color:RED">Error:</b> ${data.FBRError.mainError}</div>`;
}

if (data.FBRError.itemError) {
html += `<div><b style="color:RED">Row Error:</b> ${data.FBRError.itemError}</div>`;
}

const tooltip = new Tooltip({
content: html,
opensOn: "Hover",
position: "TopLeft",
mouseTrail: true,
offsetX: 20
});

tooltip.appendTo(row);
rowTooltips.push(tooltip); // ⭐ STORE INSTANCE

return;
}

// ✔ Valid rows (green)
if (data.validateRow && data.FBRValidObject) {
row.classList.add("has-valid-row");
return;
}
}
    }
  >
 
 <ColumnsDirective>

<ColumnDirective  headerText="Validate" width="120"
  textAlign="Left" headerTextAlign="Center" commands={validateButton}/>
<ColumnDirective  headerText="Post" width="90"
  textAlign="Left" headerTextAlign="Center" commands={postButton}/>

<ColumnDirective field="ExcelRowID" headerText="Excel Row ID" width="150"
  textAlign="Left" headerTextAlign="Center" allowEditing={false} />

<ColumnDirective field="EntryNo" headerText="Entry No" width="150"
  textAlign="Right" headerTextAlign="Center" allowEditing={false} />

<ColumnDirective field="invoiceDate" headerText="Invoice Date" width="130"
  textAlign="Left" headerTextAlign="Center" editType="datepickeredit" allowEditing={true} />

<ColumnDirective field="ChallanNo" headerText="REFERENCE NO" width="180"
  textAlign="Left" headerTextAlign="Center"  />
<ColumnDirective field="invoiceRefNo" headerText="Invoice Ref No" width="150"
  textAlign="Right" headerTextAlign="Center" allowEditing={false} />

<ColumnDirective field="sellerNTNCNIC" headerText="Seller NTN CNIC" width="150"
  textAlign="Right" headerTextAlign="Center" />

<ColumnDirective field="sellerBusinessName" headerText="Seller Business Name" width="150"
  textAlign="Right" headerTextAlign="Center" />

<ColumnDirective field="sellerProvince" headerText="Seller Province" width="150"
  textAlign="Right" headerTextAlign="Center" />

<ColumnDirective field="buyerProvince" headerText="Buyer Province" width="150"
  textAlign="Right" headerTextAlign="Center" />

<ColumnDirective field="invoiceType" headerText="Invoice Type" width="130"
  textAlign="Left" headerTextAlign="Center" allowEditing={false} />

<ColumnDirective field="buyerNTNCNIC" headerText="Buyer NTN / CNIC" width="140"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="buyerBusinessName" headerText="Buyer Business Name" width="140"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="sellerAddress" headerText="Seller Address" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="buyerAddress" headerText="Buyer Address" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="buyerRegistrationType" headerText="Buyer Registration Type" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="FBRbuyerRegistrationType" headerText="FBR Registration Type" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="scenarioId" headerText="Scenario Id" width="180"
  textAlign="Left" headerTextAlign="Center" visible={props.isSendBox} />


<ColumnDirective field="HSCode" headerText="HS Code" width="120"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="productDescription" headerText="Product Description" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="rate" headerText="Rate" width="100"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit"
   />

<ColumnDirective field="UOM" headerText="UOM" width="100"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="quantity" headerText="Quantity" width="100"
  textAlign="Right" headerTextAlign="Center"
  format="N2" edit={{ format: 'n2' }} editType="numericedit" />

<ColumnDirective field="totalValues" headerText="Total Values" width="120"
  textAlign="Right" headerTextAlign="Center"
  format="N2" edit={{ format: 'n2' }} editType="numericedit" />

<ColumnDirective field="valueSalesExcludingST" headerText="Sales Value (Excl. ST)" width="162"
  textAlign="Right" headerTextAlign="Center"
  format="N2" edit={{ format: 'n2' }} editType="numericedit" />

<ColumnDirective field="fixedNotifiedValueOrRetailPrice" headerText="Retail / Notified Value" width="170"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit" />

<ColumnDirective field="salesTaxApplicable" headerText="Sales Tax Applicable" width="150"
  textAlign="Right" headerTextAlign="Center"
  format="N2" edit={{ format: 'n2' }} editType="numericedit" />

<ColumnDirective field="salesTaxWithheldAtSource" headerText="ST Withheld at Source" width="160"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit" />

<ColumnDirective field="extraTax" headerText="Extra Tax" width="120"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="furtherTax" headerText="Further Tax" width="120"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit" />

<ColumnDirective field="sroScheduleNo" headerText="SRO Schedule No" width="150"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="fedPayable" headerText="FED Payable" width="120"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit" />

<ColumnDirective field="discount" headerText="Discount" width="120"
  textAlign="Right" headerTextAlign="Center"
  format="N0" edit={{ format: 'n0' }} editType="numericedit" />

<ColumnDirective field="transactioN_Desc" headerText="Transaction Description" width="180"
  textAlign="Left" headerTextAlign="Center" />

<ColumnDirective field="sroItemSerialNo" headerText="SRO Item Serial No" width="150"
  textAlign="Left" headerTextAlign="Center" />

</ColumnsDirective>

<AggregatesDirective>

  {/* ==== TOTAL FOOTER SUM ==== */}
  <AggregateDirective>
    <AggregateColumnsDirective>

      <AggregateColumnDirective field="discount" type="Sum" format="N0"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="fedPayable" type="Sum" format="N0"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="furtherTax" type="Sum" format="N0"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="salesTaxWithheldAtSource" type="Sum" format="N0"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="salesTaxApplicable" type="Sum" format="N2"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="fixedNotifiedValueOrRetailPrice" type="Sum" format="N0"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="valueSalesExcludingST" type="Sum" format="N2"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="totalValues" type="Sum" format="N2"
        footerTemplate={footerSum} />

      <AggregateColumnDirective field="quantity" type="Sum" format="N2"
        footerTemplate={footerSum} />

    </AggregateColumnsDirective>
  </AggregateDirective>


  {/* ==== GROUP FOOTER SUM ==== */}
  <AggregateDirective>
    <AggregateColumnsDirective>

      <AggregateColumnDirective field="discount" type="Sum" format="N0"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="fedPayable" type="Sum" format="N0"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="furtherTax" type="Sum" format="N0"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="salesTaxWithheldAtSource" type="Sum" format="N0"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="salesTaxApplicable" type="Sum" format="N2"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="fixedNotifiedValueOrRetailPrice" type="Sum" format="N0"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="valueSalesExcludingST" type="Sum" format="N2"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="totalValues" type="Sum" format="N2"
        groupFooterTemplate={footerSum} />

      <AggregateColumnDirective field="quantity" type="Sum" format="N2"
        groupFooterTemplate={footerSum} />

    </AggregateColumnsDirective>
  </AggregateDirective>

</AggregatesDirective>



<Inject
            services={[
              Edit,
              Toolbar,
              Page,
              Sort,
              PdfExport,
              ExcelExport,
              Filter,
              Group,
              Aggregate,
              Freeze,
              ColumnChooser,
              Reorder,
              Resize,
              CommandColumn,
            ]}
          />
  </GridComponent>
  )}
  </div>
  </div>


</div>
    </>
  )
}

